import { PermissionCheckService } from "@/core/services";
import { setWorkspaceUserPermissionsAtom, workspaceUserPermissionsAtom } from "@/store/workspace";
import { useAtom, useAtomValue } from "jotai";

interface UseUserPermissionsProps {
  permissions: string[];
  setPermissions: () => Promise<void>;
  hasAllPermissions: (permissions: string[]) => boolean;
  hasAnyPermission: (permissions: string[]) => boolean;
}

export const useUserPermissions = (): UseUserPermissionsProps => {
  // Read-only atoms
  const permissions = useAtomValue(workspaceUserPermissionsAtom);

  // Actions
  const [, setPermissions] = useAtom(setWorkspaceUserPermissionsAtom);

  // Services to check permissions
  const permissionCheckService = new PermissionCheckService();

  const hasAnyPermission = (requiredPermissions: string[]) => {
    return permissionCheckService.hasAnyPermission(requiredPermissions, permissions.permissions);
  };

  const hasAllPermissions = (requiredPermissions: string[]) => {
    return permissionCheckService.hasAllPermissions(requiredPermissions, permissions.permissions);
  };

  return {
    permissions: permissions.permissions,
    setPermissions,
    hasAllPermissions,
    hasAnyPermission,
  };
};
